import type { FilterModule } from "../index";
import { KnownCompaniesFilter } from "./KnownCompaniesFilter";
import { defaultKnownCompaniesSlice, type KnownCompaniesSlice } from "./slice";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { getChips, getCount } from "./chips";

export const knownCompaniesModule: FilterModule<KnownCompaniesSlice> = {
  key: "knownCompanies",
  defaultSlice: defaultKnownCompaniesSlice,
  Component: KnownCompaniesFilter,
  toCompanyFilters,
  fromCompanyFilters,
  getChips,
  getCount,
};

export type { KnownCompaniesSlice } from "./slice";
export { defaultKnownCompaniesSlice } from "./slice";
export type { KnownCompaniesOptions } from "./options";
export type { HgIdColumn } from "./detectHgIdColumn";
